import type {
  ImportChannelReservationRequestDto,
  SyncChannelRatesAvailabilityRequestDto,
} from "./dtos.ts";

function requireValue(value: string | undefined, message: string) {
  return value?.trim() ? "" : message;
}

export function validateImportChannelReservationRequest(request: ImportChannelReservationRequestDto) {
  return {
    connectionId: requireValue(request.connectionId, "Connection is required."),
    externalReservationId: requireValue(request.reservation.externalReservationId, "External reservation id is required."),
    guestLabel: requireValue(request.reservation.guestLabel, "Guest label is required."),
    arrival: requireValue(request.reservation.arrival, "Arrival is required."),
    departure: requireValue(request.reservation.departure, "Departure is required."),
    roomTypeId: requireValue(request.reservation.roomTypeId, "Room type is required."),
  };
}

export function validateSyncChannelRatesAvailabilityRequest(request: SyncChannelRatesAvailabilityRequestDto) {
  return {
    connectionId: requireValue(request.connectionId, "Connection is required."),
    idempotencyKey: requireValue(request.idempotencyKey, "Idempotency key is required."),
    payload:
      request.rates.length > 0 || request.availability.length > 0
        ? ""
        : "At least one rate or availability row is required.",
  };
}
